import { PermissionRequestDto } from '@careapp-group/ng-sdk-v2-new';
import { CareAppListActionFactory, PayloadAction } from '../action-factory';

class RequestActions extends CareAppListActionFactory<PermissionRequestDto> {
  constructor(name) {
    super(name);
  }

  get REQUEST_APPROVE_REQUEST() {
    return `[${this.type}][Request] approve`;
  }
  get REQUEST_DENY_REQUEST() {
    return `[${this.type}][Request] deny`;
  }

  get RESPONSE_SUCCESS_RESPOND() {
    return `[${this.type}][Response][Success] Respond To Request`;
  }
  get RESPONSE_FAIL_RESPOND() {
    return `[${this.type}][Response][Fail] Respond To Request`;
  }

  RequestApproveAction(payload) {
    return {
      type: this.REQUEST_APPROVE_REQUEST,
      payload: payload,
    };
  }

  ResponseSuccessRespondAction(payload: any): PayloadAction {
    return {
      type: this.RESPONSE_SUCCESS_RESPOND,
      payload,
    };
  }
  ResponseFailRespondAction(payload: any): PayloadAction {
    return {
      type: this.RESPONSE_FAIL_RESPOND,
      payload,
    };
  }

  RequestDenyAction(payload) {
    return {
      type: this.REQUEST_DENY_REQUEST,
      payload: payload,
    };
  }
}

export const Requests = new RequestActions(`Requests`);
